import type { RouteObject } from 'react-router';

import { FilterGroupsScreen } from './filterGroups/FilterGroupsScreen';
import { GeolocationManagementScreen } from './geolocations/management/GeolocationManagementScreen';
import { NotFoundChildRoute } from 'src/app/NotFoundChildRoute';

export const settingsRoutes: RouteObject[] = [
  {
    index: true,
    lazy: () =>
      import('./organization-settings-management/OrganizationSettingsManagementRoute').then(
        (m) => ({ Component: m.default })
      ),
  },
  {
    path: 'tags',
    lazy: () =>
      import('./tag/management/TagManagementRoute').then((m) => ({
        Component: m.TagManagementRoute,
      })),
  },
  {
    path: 'payments',
    lazy: () =>
      import('./payments/PaymentsConnectScreen').then((m) => ({
        Component: m.PaymentsConnectScreen,
      })),
  },
  {
    path: 'filter-groups',
    Component: FilterGroupsScreen,
  },
  {
    path: 'geolocations',
    Component: GeolocationManagementScreen,
  },
  {
    path: 'messages',
    lazy: () =>
      import('./messages/MessageSettingsScreen').then((m) => ({
        Component: m.MessageSettingsScreen,
      })),
  },
  {
    path: 'trip-request-form',
    lazy: () =>
      import('./trip-request-form/TripRequestFormScreen').then((m) => ({
        Component: m.TripRequestFormScreen,
      })),
  },
  {
    path: 'notifications',
    lazy: () =>
      import('./notifications/NotificationSettingsScreen').then((m) => ({
        Component: m.NotificationSettingsScreen,
      })),
  },
  {
    path: '*',
    element: (
      <NotFoundChildRoute
        routePath="/settings"
        linkText="Go back to settings"
      />
    ),
  },
];
